import React from 'react'
import { Trans } from '@lingui/macro'
import { useDispatch, useSelector } from 'react-redux'
import { getColor } from 'components/utils'
import { Alert } from 'components/UI/Alert/Alert'



import { IdCashDesksState } from 'model/dashboardCashDesks/dCashDesksReducer';
import {

    dCashDesksSetDetailItemAC
} from 'model/dashboardCashDesks/dCashDesksActionCreators';
import { MinusSmIcon, PlayIcon, StopIcon } from '@heroicons/react/outline';

// Type
export type typeTableHeader = {
    variant?: string

}

// Header data component
export const TableHeader: React.FC<typeTableHeader> = () => {


    return (
        <>
            <th scope="col"
                className="px-4 py-3 text-left text-xs font-medium  uppercase tracking-wider">
                <Trans>Store name</Trans>
            </th>
            <th scope="col"
                className="px-4 py-3 text-left text-xs font-medium  uppercase tracking-wider">
                <Trans>Desk number</Trans>
            </th>
            <th scope="col"
                className="px-4 py-3 text-left text-xs font-medium  uppercase tracking-wider">
                <Trans>Equipment model</Trans>
            </th>
            <th scope="col"
                className="px-4 py-3 text-left text-xs font-medium  uppercase tracking-wider">
                <Trans> Equipment SN</Trans>
            </th>
            {process.env.REACT_APP_CUSTOMER !== 'SKAPPSK' && <th scope="col"
                  className="px-4 py-3 text-left text-xs font-medium  uppercase tracking-wider">
                <Trans>Fiscal Card Id</Trans>
            </th> }
            <th scope="col"
                className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">
                <Trans>Status</Trans>
            </th>

        </>

    )
}


// Type
export type typeAction = {
    title: JSX.Element,
    disableSwitcher?: boolean,
    action: (id: string) => void,
}

export type typeTableBody = {
    variant?: string
    rowsActions?: typeAction[]
    setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>
}


// Body data component
export const TableBody: React.FC<typeTableBody> = ({ variant,setOpenPopupDetails }) => {

    const color = getColor(variant)

    const dispatch = useDispatch()

    const tableData = useSelector((state: { dCashDesks: IdCashDesksState }) => state.dCashDesks.data)

    let component


    const onCellClickHandler = ( e: React.MouseEvent<HTMLTableDataCellElement, MouseEvent>, id: string) => {
        dispatch(dCashDesksSetDetailItemAC(id))
        setOpenPopupDetails(true)
    }

    if (tableData.length) {
        component = tableData.map((item, index) => {
            return (
                <tr key={ item.id }
                    className={ `${ index % 2 === 0 ? 'bg-white' : 'bg-gray-50' } hover:bg-${ color }-50` }>
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900 cursor-pointer" onClick={(e) => onCellClickHandler(e, item.id)}>
                        { item.store? item.store.name : <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div>}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900 cursor-pointer" onClick={(e) => onCellClickHandler(e, item.id)}>
                        { item.posNumber? item.posNumber : <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div>}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer cursor-pointer" onClick={(e) => onCellClickHandler(e, item.id)}>
                        { item.posHardwareModel? item.posHardwareModel: <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div>}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer" onClick={(e) => onCellClickHandler(e, item.id)}>
                        { item.posHardwareSerialNumber? item.posHardwareSerialNumber: <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div>}
                    </td>

                    {process.env.REACT_APP_CUSTOMER !== 'SKAPPSK' && <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer"
                          onClick={ (e) => onCellClickHandler(e, item.id) }>
                        { item.fiscalCardId ? item.fiscalCardId :
                            <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div> }
                    </td> }
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer" onClick={(e) => onCellClickHandler(e, item.id)}>
                        { item.blocked ? <div className="flex justify-center" title={'blocked'}><StopIcon className="h-5 w-5 text-red-400"/></div>:<div className="flex justify-center" title={'not blocked'}><PlayIcon className="h-5 w-5 text-green-400"/></div>}
                    </td>
                </tr>
            )
        })
    } else {
        component = <tr>
            <td className="p-2" colSpan={ 6 }>
                <Alert className="w-full" type={ 'info' }
                       title={ <Trans>The cash desks list is empty. Call to support to add a new cash desk or check filters.
                           </Trans> }/>
            </td>
        </tr>
    }

    return (
        <>
            { component }
        </>
    )
}
